import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import "./Partner.css";

export const Partner = () => {
  const [partnersDetails, setPartnersDetails] = useState([]);
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const pageUrl = `${origin}/partnerships`;
  const description = "Join the FlintHost Partner Program to earn recurring commission and share high-performance hosting with your community.";
  useEffect(() => {
    fetch('/partners.json')
      .then(res => res.json())
      .then(data => setPartnersDetails(data))
      .catch(error => console.error(error));
  }, []);
  return (
    <div className="partner-page">
      <Helmet>
        <title>FlintHost | Partner Program</title>
        <meta name="description" content={description} />
        <meta property="og:title" content="FlintHost | Partner Program" />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={`${origin}/img/Logo2.png`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="FlintHost | Partner Program" />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={`${origin}/img/Logo2.png`} />
      </Helmet>
      <section className="partner-hero">
        <div className="partner-hero-content">
          <p className="partner-eyebrow">Partner Program</p>
          <h1>Become a FlintHost Partner</h1>
          <p>
            Earn recurring commission, grow with us, and give your audience high-performance game hosting that feels effortless.
          </p>
        </div>
        <div className="partner-hero-cards">
          <div className="partner-stat">
            <span>20%</span>
            <p>Recurring commission on every referral</p>
          </div>
          <div className="partner-stat">
            <span>Lifetime</span>
            <p>Earn as long as your customer stays active</p>
          </div>
          <div className="partner-stat">
            <span>Custom</span>
            <p>Branded referral links available on request</p>
          </div>
        </div>
      </section>

      <section className="partner-section">
        <div className="partner-grid">
          <div className="partner-card">
            <h2>Share your link</h2>
            <p>We’ll give you a unique referral link to share with your community and socials.</p>
          </div>
          <div className="partner-card">
            <h2>Earn credits or cash out</h2>
            <p>Use credits on your own servers or withdraw straight to your payment account.</p>
          </div>
          <div className="partner-card">
            <h2>Keep earning</h2>
            <p>Every recurring payment keeps your 20% commission flowing month after month.</p>
          </div>
        </div>
        <div className="partner-example">
          <h3>Example earnings</h3>
          <p>If someone buys a $20 server, you earn $4.</p>
        </div>
        <a href="/contact" className="partner-cta">Contact us to start</a>
      </section>

      <section className="partner-section">
        <div className="partner-heading">
          <h2>Our partners</h2>
          <p>Creators and communities growing with FlintHost.</p>
        </div>
        <div className="partner-list">
          {partnersDetails.map(partnersDetail => (
            <div key={partnersDetail.name} className="partnerbox">
              <img src={partnersDetail.imageurl} alt={partnersDetail.name} />
              <div>
                <a href={partnersDetail.external}>{partnersDetail.name}</a>
                <p>{partnersDetail.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};
